const data = [ // 数据数组
  {
    coverUrl: "https://www.csvw.com/u/cms/www/202007/3016360702P4.png", // 封面URL
    coverTitle: "入门指南", // 封面标题
    coverText: "快速上手，爱车功能全知道。", // 封面文字
    menu: [ // 该封面下的内容
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202007/301508351Zn0.png", // 一级菜单图标地址
        iconSelect:
          "https://www.csvw.com/u/cms/www/202007/3113194032wI_700_410.png", // 一级菜单选中图标地址
        text: "揭晓汽车安全的密码", // 一级菜单文字
        subItem: [ // 二级菜单
          {
            text: "辅助驾驶功能", // 二级菜单文字
            content: [ // 二级菜单点击对应的页面内容数组
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/19171716tByz.mp4", // 页面内容的视频地址
                contentUrl: // 页面内容的图片地址
                  "https://www.csvw.com/u/cms/www/202007/31134139CCvS_700_410.jpg",
                contentText: "这个是测试测试的第1111级骷髅精灵", // 页面内容的文字
                contentTitle: "111", // 页面内容的标题
                navTitle: "111", // 页面切换页签标题
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202007/30163453pK9k.png",
                contentText: "这个是测试测试的第2222级骷髅精灵",
                contentTitle: "222",
                navTitle: "222",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202007/301635440093.png",
                contentText: "这个是测试测试的第333333骷髅精灵",
                contentTitle: "333",
                navTitle: "3333",
              },
            ],
          },
          {
            text: "娱乐功能",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202007/30163453pK9k.png",
                contentText: "这个是测试测试的第2222级骷髅精灵",
                contentTitle: "222",
                navTitle: "222",
              },
            ],
          },
        ],
      },
    ],
  },
];




const data1 = [
  {
    coverUrl: "https://www.csvw.com/u/cms/www/202007/3016360702P4.png",
    coverTitle: "入门指南",
    coverText: "揭晓汽车的安全密码",
    menu: [
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202007/301508351Zn0.png",
        iconSelect:
          "https://www.csvw.com/u/cms/www/202008/16175612y75K.png",
        text: "揭晓汽车的安全密码",
        subItem: [
          {
            text: "安全驾驶系统",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07104601U676.jpg",
                contentText: "通过安装在四个轮胎内的高灵敏度压力传感器，让驾驶者对每一只轮胎的胎压状况了如指掌，当胎压太低或漏气时，系统会自动报警提醒。",
                contentTitle: "主动胎压监控",
                navTitle: "主动胎压监控",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07104651N3z3.jpg",
                contentText: "在车速大于60km/h的情况下，系统将激活开始工作，通过数十个传感器记录驾驶者的驾驶行为和驾驶风格，当监测到驾驶者出现疲倦特征时，会通过仪表盘出现的咖啡杯标识以及发出的蜂鸣声，提醒驾驶者及时停车休息，避免疲劳驾驶。",
                contentTitle: "疲劳监测",
                navTitle: "疲劳监测",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/19101539u217.jpg",
                contentText: "在行驶的过程中，系统会通过车辆前方的夜视摄像头捕捉最远至300米的热源目标物，将监测到的行人及大型动物标记在显示屏上。 同时，当系统判断存在碰撞风险时，便会向驾驶者发出声音警告，还可控制大灯闪烁提醒行人避让。",
                contentTitle: "红外线夜视成像",
                navTitle: "红外线夜视成像",
              },

              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/25103132n9Nh.jpg",
                contentText: "该系统会在监测到车辆发生碰撞后启动，自动施加制动并调整车辆姿态，将汽车时速降至10km/h以下，降低车辆发生侧滑与多次碰撞的风险。",
                contentTitle: "多次碰撞预防",
                navTitle: "多次碰撞预防",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/191016426509.jpg",
                contentText: "它运用传感器自动分析前后方的车辆行驶状况，若系统识别到两车车距过近，存在碰撞危险时，将会自动激活安全预防措施，控制车辆安全带预收紧，并关闭侧窗和天窗，以备快速应对可能发生的冲击。",
                contentTitle: "预碰撞安全保护",
                navTitle: "预碰撞安全保护",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071047091Yh5.jpg",
                contentText: "安全气囊是被动安全的保护系统，与座椅安全带配合，对驾驶员和乘员进行保护。",
                contentTitle: "安全气囊",
                navTitle: "安全气囊",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07104738P6A2.jpg",
                contentText: "前后排一体式安全气帘是贯穿车侧的从前到后的大的安全气囊，前后一体式主要是结合了侧排气囊和后气囊的作用，保护主副驾驶位侧方和后排乘坐人的安全。",
                contentTitle: "前后排头部安全气帘",
                navTitle: "前后排头部安全气帘",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/27132211KR6E.jpg",
                contentText: "驾乘人员在汽车行驶过程中，未系安全带时发出警告提示。",
                contentTitle: "前排安全带未系报警",
                navTitle: "前排安全带未系报警",
              },
            ],
          },
          {
            text: "车身动态电子稳定系统",
            content: [
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251014284645.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07105029BX94.jpg",
                contentText:
                  "制动防抱死系统，在汽车制动时，自动控制制动器制动力的大小，使车轮不被抱死，处于边滚边滑的状态，从而保证车辆紧急制动的安全系数。",
                contentTitle: "ABS",
                navTitle: "ABS",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25101515g59n.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07105058vt42.jpg",
                contentText:
                  "驱动防滑系统，通过减少节气门开度来降低发动机功率或者由制动器控制车轮打滑来达到对汽车牵引力的控制，进而防止车辆尤其是大马力车辆，在起步、加速时驱动轮打滑现象，以维持车辆行驶方向的安全稳定性。",
                contentTitle: "ASR",
                navTitle: "ASR",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25101542xc48.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/10101334qop4.jpg",
                contentText:
                  "电子差速锁，是ABS的一种扩展功能，通过ABS 系统的传感器，自动探测到由于车轮打滑或悬空而产生的两侧车轮转速不同的现象时，就会通过ABS系统对打滑一侧的车轮进行制动，从而使驱动力有效地作用到非打滑侧的车轮，进而保障行车安全。",
                contentTitle: "EDS",
                navTitle: "EDS",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25101611Ne9T.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071051360H25.jpg",
                contentText:
                  "发动机阻力矩控制系统，借助ABS传感器对滑移率的识别，自动降低发动机阻力矩，达到降低滑移率的目的，从而保证车辆在雨天或冰雪路面上行驶时的稳定性。",
                contentTitle: "MSR",
                navTitle: "MSR",
              },
            ],
          },
          {
            text: "停车辅助系统",
            content: [
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25101707z7iX.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07105245n79a.jpg",
                contentText:
                  "系统启动后，将运用超声波传感器扫描路面两侧，智能寻找合适停车位，且泊车时可自动转向，驾驶者仅需控制刹车和油门即可完成泊车。",
                contentTitle: "智能泊车辅助系统",
                navTitle: "智能泊车辅助系统",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251017580T46.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/191014187v1x.jpg",
                contentText:
                  "4个超广角高清鱼眼摄像头负责拍摄车身环境，并形成一幅360°全景影像俯视图，实时传送到中控屏上。 驾驶者还可以点触屏幕，选择不同视角，更加清楚的看到车身某个方向的具体情况。",
                contentTitle: "360°鸟瞰式全景可视行车辅助系统",
                navTitle: "360°鸟瞰式全景可视行车辅助系统",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071052051T0W.jpg",
                contentText:
                  "倒车影像是汽车泊车或倒车时的安全辅助装置,能以影像显示告知驾驶员周围障碍物的情况,解除了驾驶员泊车、倒车和起动车辆时前后左右探视所引起的困扰,帮助驾驶员扫除视野死角和视线模糊的缺陷,提高驾驶的安全性。",
                contentTitle: "倒车影像",
                navTitle: "倒车影像",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07105226t4Fu.jpg",
                contentText:
                  "前后驻车雷达是一项汽车安全辅助装置。前后驻车雷达用于汽车泊车或慢速行驶时探测汽车前后方障碍物，提供障碍物距离、方位、区域等信息，并适时报警，为司机泊车、慢速行驶或拥堵时跟车、并线等提供方便，并帮助其减少或消除前进时因视线不良而引起的碰撞、刮蹭事故。",
                contentTitle: "前后驻车雷达",
                navTitle: "前后驻车雷达",
              },
            ],
          },
          {
            text: "行车辅助系统",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/25103245GO42.jpg",
                contentText:
                  "将行车过程中的临时性制动和停车后的长时性制动功能整合在一起，并且由电子控制方式实现停车制动的技术。启动自动电子驻车制动的情况下，能够避免车辆不必要的滑行。",
                contentTitle: "电子驻车制动系统",
                navTitle: "电子驻车制动系统",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07105333T14y.jpg",
                contentText:
                  "基于ABS、ASR集成的控制系统的汽车坡道起步辅助装置。保证坡道起步车辆不会后溜，提高了车辆在坡道起步、驻车等情况下的驾驶舒适便利性。",
                contentTitle: "坡道辅助系统",
                navTitle: "坡道辅助系统",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071054320cM8.jpg",
                contentText:
                  "驾驶员在行车过程时，通过有效检测方式来判断驾驶员是否手握住方向盘，从而保障行车安全。",
                contentTitle: "HOD系统",
                navTitle: "HOD系统",
              },
            ],
          },
        ],
      },
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202008/161759014k00.png",
        iconSelect:
          "https://www.csvw.com/u/cms/www/202008/161758387rTP.png",
        text: "汽车功能全介绍",
        subItem: [
          {
            text: "辅助驾驶功能",
            content: [
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251020032bAD.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071055409t80.jpg",
                contentText:
                  "能够在0-150km/h的范围内工作，自由选择跟车距离和跟车速度，且能够自动保持、时刻矫正自身与前车间的距离，进行安全巡航。 若前车停止，本车亦可自动减速至车完全停止。 如果前车在3秒内重新起步，本车亦能随即起步，跟上前车。",
                contentTitle: "ACC 3.0第三代自适应定速巡航系统",
                navTitle: "ACC 3.0",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251020514vA5.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07110021y7I2.jpg",
                contentText:
                  "能够时刻监控与前车的距离并识别危险距离。当识别到一个潜在碰撞事故时，可以发出警告并自动制动；若潜在碰撞事故发生时，它有助于在系统极限内减轻事故后果或在理想的情况下避免事故。",
                contentTitle: "Front Assist前部辅助系统",
                navTitle: "Front Assist",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25102158oV6Z.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07110114PQ5u.jpg",
                contentText:
                  "时刻监测道路上的车道线标记，在车速大于65km/h的情况下将激活开始工作，一旦发现偏离行驶车道，系统就会发出警告，并主动修正行驶方向，让车辆时刻保持在当前的车道上。",
                contentTitle: "Lane Assist车道保持系统",
                navTitle: "Lane Assist",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25102233IyM4.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071101346bR4.jpg",
                contentText:
                  "通过后保险杠上的雷达扫描车后方几十米内的距离，探测邻近车辆行驶状况，若后视镜盲区内有车辆快速接近，外后视镜上的黄色LED等便会亮起警示车主，帮助判断变道时机。",
                contentTitle: "Side Assist变道辅助系统",
                navTitle: "Side Assist",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251023111LO9.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071101558s49.jpg",
                contentText:
                  "使车辆能够以低速行驶的状态在交通拥堵的路况中，实现自动跟车和车道保持。",
                contentTitle: "Traffic Jam Assist交通拥堵辅助系统",
                navTitle: "Traffic Jam Assist",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25102354F069.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711021419t5.jpg",
                contentText:
                  "可分析前方交通状况，识别横穿街道的行人，必要时通过声光报警提醒驾驶员或触发制动，防止危险的发生。",
                contentTitle: "AEB智能守护刹车辅助系统",
                navTitle: "Autonomous Emergency Braking",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/19172026z5D8.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/191016223533.jpg",
                contentText: "以无级调节方式分配前后轮所需的动力，获得更多动态性能，从容应对特殊地形，令全路况尽在掌控中，保障行驶稳定与安全。",
                contentTitle: "全时四驱",
                navTitle: "全时四驱",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/19172107395P.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/191017088q0l.jpg",
                contentText: "它的每一个空气弹簧都单独作用于一个轮胎，可根据行驶条件智能调整，使车身始终保持在理想的行驶高度。再与驾驶模式选择功能相结合，可带来或舒适或运动的多种体验。",
                contentTitle: "自适应空气悬架",
                navTitle: "自适应空气悬架",
              },
            ],
          },
          {
            text: "娱乐功能",
            content: [
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25102559X40o.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071106428iDj.jpg",
                contentText:
                  "集娱乐系统、手机互联、3D导航于一身，其丰富的功能和智能化的操作使旅途充满愉悦。",
                contentTitle: "高级智能多媒体交互系统（带智能导航）",
                navTitle: "高级智能多媒体交互系统",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/25102634W8K2.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07110659Cj4N.jpg",
                contentText:
                  "作为汽车中的电子娱乐设备，是驾驶者行车途中的完美伴侣。比如威然搭载的丹拿皇家殿堂级音响系统, ，把声音的流畅、精准的动态表现发挥到了极致，打造出犹如聆听现场演奏般的自然环绕声场。",
                contentTitle: "音响系统",
                navTitle: "音响系统",
              },
            ],
          },
          {
            text: "车内空气质量",
            content: [
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/2510273202XC.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07110819J80d.jpg",
                contentText:
                  "三区自动空调系统是指在主、副驾驶侧和后排空间三个温区，皆可独立调节温度和空气气流，满足不同乘员的个性化需求。贴心的让每一位乘客，都能享受到适合自己的温度。前排左右两侧各自可独立进行温度调节，后排空间的温度则通过位于中央扶手处的空调控制面板来调节。",
                contentTitle: "三区自动空调系统",
                navTitle: "三区自动空调系统",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711073549oP.jpg",

                contentText:
                  "AQS (Air Quality System)，空气质量模块，能够灵敏感知车外空气浊度、湿度并随即切换空气内外循环的自动装置。",
                contentTitle: "AQS空气质量自动控制系统",
                navTitle: "AQS空气质量自动控制系统",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/251028273m9C.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/21170454c7U1.jpg",
                contentText:
                  "当车主打开内循环或者外循环时，cleanair功能就会自动开启，过滤有害的气体，保证车内空气环境的干净。",
                contentTitle: "Clean airPM2.5空气净化装置",
                navTitle: "Clean airPM2.5空气净化装置",
              },
            ],
          },
          {
            text: "便捷使用功能",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711114394Ix.jpg",
                contentText:
                  "汽车车载无线充作为一种绝佳的无线充电应用场景，无需频繁插拔充电线，是增加行车安全、提高车主生活品质的一大利器，极大的改善了车内手机使用和充电的体验。",
                contentTitle: "手机无线充电功能",
                navTitle: "手机无线充电功能",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/241419146390.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/1717432028a6.jpg",
                contentText:
                  "随身携带行李靠近行李厢时，只需利用脚部扫描后保险杠下缘的感应器，行李厢盖即会自动开启。在您双手被占用的时候也可以方便的打开后备箱来放置物品。",
                contentTitle: "行李箱盖感应开启",
                navTitle: "行李箱盖感应开启",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111204U1rZ.jpg",
                contentText:
                  "只要随身携带智能感应钥匙靠近车体时，正副驾驶席车门及尾门便会分别自动感应，伸手拉动门把手即可解锁打开。",
                contentTitle: "无钥匙进入系统",
                navTitle: "无钥匙进入系统",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/19102436V8VD.jpg",
                contentText: "利用光学反射原理，将当前速度、导航路径等关键行驶信息投射显示在驾驶者视线2米处，与驾驶者视线平行，阅读信息快速便捷，使驾驶更专注。",
                contentTitle: "HUD平视显示系统",
                navTitle: "HUD平视显示系统",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    coverUrl: "https://www.csvw.com/u/cms/www/202007/3016360702P4.png",
    coverTitle: "品质讲堂",
    coverText: "",
    menu: [
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202008/05163946Y50W_700_410.png",
        iconSelect:
          "https://www.csvw.com/u/cms/www/202008/051639131j35_700_410.png",
        text: "品质把控 精益求精",
        subItem: [
          {
            text: "质保中心：气味实验室",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111325ta2Q.jpg",
                contentText: "从2018年开始，上汽大众的产品内饰零件不再使用溶剂型胶水，取而代之的是卡扣或焊接方式，致力于打造“无溶剂”的健康座舱。",
                contentTitle: "“无溶剂”健康座舱",
                navTitle: "“无溶剂”健康座舱",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711134708P5.jpg",
                contentText: "重点内饰零部件，如座椅面套、车顶、方向盘等，在下线后，就拿到“桑拿房”里烘烤除毒除味。",
                contentTitle: "“内饰桑拿房”",
                navTitle: "“内饰桑拿房”",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711140581Bp.jpg",
                contentText: "（整车有毒有害及气味物质的浓度总和）攻关，上汽大众制定了大众汽车集团中国区第一份针对整车材料的标准，部分要求甚至高于集团全球标准，更符合中国消费者对车内空气的需求。",
                contentTitle: "TVOC攻关",
                navTitle: "TVOC攻关",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111421X445.jpg",
                contentText: "上汽大众拥有一群嗅觉特别灵敏的专业人士，他们负责人工检测新车的气味，能熟练分辨出105种气味类型。他们接受过专业的培训，对整车及零部件、原材料的气味开展严格测评，确保座舱空气的安全与适宜。",
                contentTitle: "金鼻子",
                navTitle: "金鼻子",
              },
            ],
          },
          {
            text: "质保中心：色差小组",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071115133JGg.jpg",
                contentText: "为了不断提升客户的视觉满意度，上汽大众遵循全球领先的大众汽车集团色差标准，并且在此基础上综合工程师目视和设备测量数据，从颜色、光泽和表面质量三个方面对零件外观进行评价，确保了每一辆产品车的内饰件与外观匹配。",
                contentTitle: "色差小组",
                navTitle: "色差小组",
              },
            ],
          },
          {
            text: "质保中心：工业CT",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111536420X.jpg",
                contentText: "上汽大众是国内整车行业第一家，也是目前少数几家使用工业CT的公司.工业CT应用于零部件内部缺陷分析，可以有效的避免重叠效应导致的遮挡问题，提高缺陷检测的分辨率与灵敏度，更易于缺陷的精准定位和分析。",
                contentTitle: "工业CT",
                navTitle: "工业CT",
              },
            ],
          },
          {
            text: "质保中心：内应力实验室",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711155951X3.jpg",
                contentText: "上汽大众早在2013年就引进了GE公司生产的XRD3003内应力仪，主要检测发动机、变速箱、底盘等金属零件的内应力。通过内应力仪，可以测出零件的内应力值以及它的应力分布情况，并指导供应商的生产，确保零件符合设计要求，在使用过程中不会发生失效。",
                contentTitle: "内应力实验室",
                navTitle: "内应力实验室",
              },
            ],
          },
          {
            text: "质保中心：拧紧实验室",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071116219p09.jpg",
                contentText: "上汽大众投入了摩擦性能测试仪和机械臂等先进设备，以大众汽车集团严苛的紧固件标准展开技术测试及分析，确保每颗螺丝在车上都被充分拧紧，给予底盘安全性以及整车舒适性基础保障。在上汽大众工厂所有车间中都对拧紧工序采用了多级扭矩监控，所有拧紧曲线和数据都被系统采集并保存，实现所有数据可追溯，保障制造过程中工艺的一致与稳定。",
                contentTitle: "拧紧实验室",
                navTitle: "拧紧实验室",
              },
            ],
          },
        ],
      },
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202008/16175957Vgue.png",
        iconSelect:
          "https://www.csvw.com/u/cms/www/202008/16175922Ebk9.png",
        text: "让世界，从此无界",
        subItem: [
          {
            text: "智能语音",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/181019104Y09.gif",
                contentText: "用户可以使用默认唤醒词“你好，大众”，也可以自己个性化定制唤醒词来唤起语音对话。自定义唤醒词可以使与语音指令之间无需间隔，激活语音直接执行指令，解放双手，提高效率。",
                contentTitle: "自定义唤醒词",
                navTitle: "自定义唤醒词",
              },
              {
                videoUrl: "https://www.csvw.com/u/cms/www/202008/18112141X95x.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/181017385hSs.mp4",
                contentText: "结合上下文场景理解，支持不多用户进行持续多轮的对话交互。",
                contentTitle: "多轮对话",
                navTitle: "多轮对话",
              },
              {

                videoUrl: "https://www.csvw.com/u/cms/www/202008/181121014m2I.mp4",
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/18101812R436.mp4",
                contentText: "依靠智能语音，可以清晰识别各种语言，不管是京腔、川普还是广东话等方言，随时心有灵犀地准确领会车主的意图。",
                contentTitle: "识别多种语种",
                navTitle: "识别多种语种",
              },
            ],
          },
          {
            text: "智慧导航",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071117169D57.gif",
                contentText: "兴趣点一键发送到车，通过车机导航至目的地。大数据分析云端路径规划，实时路况分析，并给出出行建议，避免拥堵，出行更便捷。实时交通及道路限行信息，规避限行路段，出行更效率。",
                contentTitle: "实时导航",
                navTitle: "实时导航",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071117333w3v.gif",
                contentText: "在线地图更新，根据用户出行习惯和当前城市，为用户静默更新地图，时刻保持全新地图数据，告别手动下载，无需等待更省时。",
                contentTitle: "在线地图更新",
                navTitle: "在线地图更新",
              },
            ],
          },
          {
            text: "智享娱乐",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111756l9Hd.jpg",
                contentText: "海量云端资源实时更新，内容播放无局限。个人专属账号车机互联，播放列表同步管理，操作更便捷。每月流量免费赠，无需额外购买。接入酷我音乐，支持语音搜索，驾驶更安全，个性化推荐，轻松找到喜欢的音乐。接入喜马拉雅，个性化有声内容推送，高品质音频体验，满足各个不同车载人群需求。",
                contentTitle: "在线娱乐",
                navTitle: "在线娱乐",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111813327Q.gif",
                contentText: "为用户提供车机端安卓App，丰富上汽大众智慧车联生态，提升用户用车体验。",
                contentTitle: "安卓应用商店",
                navTitle: "安卓应用商店",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111830pw95.gif",
                contentText: "支持同时连接多台外置设备，方便同行的家人和朋友轻松使用无线网络。",
                contentTitle: "车载Wi-Fi热点",
                navTitle: "车载Wi-Fi热点",
              },
            ],
          },
          {
            text: "智趣出行",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111948eW56.gif",
                contentText: "与京东平台深度合作，同级产品中，率先搭载智能家居，让车与家合二为一。从此，出发和回家也将会变得更有温度。",
                contentTitle: "智能家居",
                navTitle: "智能家居",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07111930NxsO.gif",
                contentText: "多人微信互联，组队出行，一键选择集结点，车机屏与微信端共同导航到集结位置，与组队成员位置实时共享，精彩旅途不断线。",
                contentTitle: "组队出行",
                navTitle: "组队出行",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/0711190571g7.gif",
                contentText: "与多家智慧停车场合作，可手机查看停车状态并提前交费，支持免密扣款支付，方便快捷。",
                contentTitle: "智慧停车与车内在线支付",
                navTitle: "智慧停车与车内在线支付",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112023M800.gif",
                contentText: "智能提醒用户进行车辆保养，并提供手机在线预约服务，一键预约，方便快捷。",
                contentTitle: "维保预约服务",
                navTitle: "维保预约服务",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071120071V9p.gif",
                contentText: "新车上市、保养、优惠等实用生活信息，实时推送给用户，并支持一键播报。",
                contentTitle: "实时信息推送",
                navTitle: "实时信息推送",
              },
            ],
          },
          {
            text: "智联控车",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112050m7r8.gif",
                contentText: "远程查看车辆总里程、车门车窗是否关闭，方便车主随时观察爱车状态。",
                contentTitle: "远程查看车辆状态",
                navTitle: "远程查看车辆状态",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112109J8uQ.gif",
                contentText: "机远程控制汽车解闭锁，忘记锁车也可一键解决。远程闪灯鸣笛，迅速锁定车辆位置，停车场找车不再难。",
                contentTitle: "远程控车",
                navTitle: "远程控车",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112126525F.gif",
                contentText: "用户可以通过手机App一键寻车，并查看与车辆距离，自动规划寻车路线。",
                contentTitle: "在线寻车",
                navTitle: "在线寻车",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112203nCIl.gif",
                contentText: "多重行车安全提醒，随时关注您的行车速度及车辆健康状况，首要时间杜绝安全隐患。",
                contentTitle: "行车提示",
                navTitle: "行车提示",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071122269172.gif",
                contentText: "提供更周全的车辆安全管理方案，实时掌控车辆行驶范围，车辆驶出、驶入区域。车辆不在身边，也能安全洞悉位置，自定义车辆行驶区域，防盗抢。",
                contentTitle: "电子围栏",
                navTitle: "电子围栏",
              },
            ],
          },
        ]
      }
    ],
  },
  {
    coverUrl: "https://www.csvw.com/u/cms/www/202007/3016360702P4.png",
    coverTitle: "汽车档案",
    coverText: "",
    menu: [
      {
        iconUrl: "https://www.csvw.com/u/cms/www/202008/171716134IC0.png",
        iconSelect:
          "https://www.csvw.com/u/cms/www/202008/17171538386q.png",
        text: "品牌车型背后的故事",
        subItem: [
          {
            text: "Polo的前世今生",
            content: [
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112301rUHi.jpg",
                contentText: "1975年的德国，大多数人都期望有一辆质量稳定且价格合适的小型车，来满足日常出行的需要。大众Polo应运而生。它基于奥迪50车型改造而来，采用两门掀背型外型，内饰精良考究，并搭载多项实用配置。Polo不仅继承了奥迪50高质量的优点，在价格上也更具优势。到上市四年后的1979年，第一代Polo全球累计产量已达到50万辆。这款德系两厢车走进了千家万户，大众汽车集团也开始在小型车市场中崭露头角。",
                contentTitle: "第一代Polo（1975-1981）",
                navTitle: "第一代",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112321y8Ml.jpg",
                contentText: "1981年大众品牌推出第二代Polo。这一代Polo的外观造型已经有别于从奥迪50改造而来的第一代，前脸采用了大众家族标志性的横向格栅设计，整体车型更加动感，它的车内空间也在同级车中出类拔萃，进一步加强了实用性。第二代Polo同样取得了优秀的市场表现：1983年Polo累计产量突破100万辆，仅在3年后的1986年，这个数字就达到了200万，印证了这款经典Polo的风靡程度。",
                contentTitle: "第二代Polo（1981-1994）",
                navTitle: "第二代",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112336x751.jpg",
                contentText: "1994年的巴黎车展上，第三代Polo问世。这一代Polo最大的改变，是从两门掀背变为了四门车型，在日常使用的便捷性与舒适性上，再上一层楼。大众汽车集团研发、制造、质保水平的不断提升，也同步体现在了这一代Polo上。第三代Polo的车身线条更加流畅，并符合空气动力学标准，在燃油经济性上也有了更佳表现。1998年，大众汽车集团又推出了，更具运动基因的Polo GTI。它搭载动力更强劲的引擎，以及更多注重安全与驾控的先进功能，在运动型小型车市场脱颖而出。",
                contentTitle: "第三代Polo（1994-2002）",
                navTitle: "第三代",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112352Z1g1.jpg",
                contentText: "21世纪，第四代Polo诞生。国内消费者对这一代Polo不会陌生，它正是由上汽大众在2002年引入国内的Polo车型。作为两厢车的Polo与当时国内多见的三厢轿车完全不同，但它仍凭借出众实力闯出了一片天地。这款有着“四眼大灯”、性能可靠实用的两厢车给消费者留下了深刻印象，迅速成为了广受欢迎的车型之一，也在国内A0级市场中成功树立了 “高档紧凑型轿车”形象。此后，它还与Polo GTI和Cross Polo组成了Polo家族，也留下了德系“小钢炮”的美誉。",
                contentTitle: "第四代Polo（2002-2009）",
                navTitle: "第四代",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/07112410m1NL.jpg",
                contentText: "第五代Polo是陪伴国内消费者十年时光，大家耳熟能详的一代车型。它拥有更凌厉的造型与更强劲的性能，集运动性与舒适性为一体，赢得众多青睐。Polo品牌精准把握了年轻一代的情感诉求，深入传递“年轻、时尚、动感”的品牌内涵。CTCC赛场上车手们的风驰电掣、音乐节上年轻人们的青春呐喊，都有Polo的影子，Cross Polo更是被韩寒带入了其电影处女作《后会无期》中，开启了一段段重新认识自我的冒险旅程。",
                contentTitle: "第五代Polo（2009-2019）",
                navTitle: "第五代",
              },
              {
                contentUrl:
                  "https://www.csvw.com/u/cms/www/202008/071124324Cx2.jpg",
                contentText: "2019年6月18日，上汽大众全新一代Polo plus上市，它是Polo的全球第六代车型。全新一代Polo plus基于MQB平台打造，全新锋彩设计理念、车身尺寸全维度升级、高效灵动的动力系统、多项越级驾辅科技，为消费者带来 颜值、驾控、安全等全方位的享受。",
                contentTitle: "第六代Polo（2019-）",
                navTitle: "第六代",
              },
            ],
          },]
      }],
  }
];

export { data1 };